module.exports = __webpack_public_path__ + "static/media/work_white.f81e1329.svg";